export const universitySearchJson = {
    searchtxt: '',
    pagesize: '25',
    pageno: '1',
    countryid: '',
    partnership: ''
}